var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeaderPolygonLightLarge = function SvgHeaderPolygonLightLarge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 579,
    height: 145,
    viewBox: "0 0 579 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10215_48686",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 579,
    height: 145
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.237305,
    y: 0.951172,
    width: 578.763,
    height: 143.667,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10215_48686)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M541.247 143.859L577.644 94.7998M541.247 143.859L577.644 192.919M541.247 143.859H687.42M577.644 94.7998H650.828M577.644 94.7998L650.828 192.919M650.828 94.7998L687.42 143.859M650.828 94.7998L577.644 192.919M687.42 143.859L650.828 192.919M650.828 192.919H577.644",
    stroke: "#EEEFEF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.247 46.1743L577.644 -2.45117M541.247 46.1743L577.644 94.7998M541.247 46.1743H687.42M577.644 -2.45117H650.828M577.644 -2.45117L650.828 94.7998M650.828 -2.45117L687.42 46.1743M650.828 -2.45117L577.644 94.7998M687.42 46.1743L650.828 94.7998M650.828 94.7998H577.644",
    stroke: "#EEEFEF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.334 95.2344L467.731 46.1748M431.334 95.2344L467.731 144.294M431.334 95.2344H577.507M467.731 46.1748H540.915M467.731 46.1748L540.915 144.294M540.915 46.1748L577.507 95.2344M540.915 46.1748L467.731 144.294M577.507 95.2344L540.915 144.294M540.915 144.294H467.731",
    stroke: "#EEEFEF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.334 -2.45169L467.731 -51.0771M431.334 -2.45169L467.731 46.1738M431.334 -2.45169H577.507M467.731 -51.0771H540.915M467.731 -51.0771L540.915 46.1738M540.915 -51.0771L577.507 -2.45169M540.915 -51.0771L467.731 46.1738M577.507 -2.45169L540.915 46.1738M540.915 46.1738H467.731",
    stroke: "#EEEFEF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.334 192.918L467.731 144.293M431.334 192.918L467.731 241.544M431.334 192.918H577.507M467.731 144.293H540.915M467.731 144.293L540.915 241.544M540.915 144.293L577.507 192.918M540.915 144.293L467.731 241.544M577.507 192.918L540.915 241.544M540.915 241.544H467.731",
    stroke: "#EEEFEF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.288 143.859L356.967 94.7998M320.288 143.859L356.967 192.919M320.288 143.859H467.594M356.967 94.7998H430.718M356.967 94.7998L430.718 192.919M430.718 94.7998L467.594 143.859M430.718 94.7998L356.967 192.919M467.594 143.859L430.718 192.919M430.718 192.919H356.967",
    stroke: "#EEEFEF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.375 192.918L247.054 144.293M210.375 192.918L247.054 241.544M210.375 192.918H357.681M247.054 144.293H320.805M247.054 144.293L320.805 241.544M320.805 144.293L357.681 192.918M320.805 144.293L247.054 241.544M357.681 192.918L320.805 241.544M320.805 241.544H247.054",
    stroke: "#EEEFEF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.375 95.2344L247.054 46.1748M210.375 95.2344L247.054 144.294M210.375 95.2344H357.681M247.054 46.1748H320.805M247.054 46.1748L320.805 144.294M320.805 46.1748L357.681 95.2344M320.805 46.1748L247.054 144.294M357.681 95.2344L320.805 144.294M320.805 144.294H247.054",
    stroke: "#EEEFEF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.288 46.1743L356.967 -2.45117M320.288 46.1743L356.967 94.7998M320.288 46.1743H467.594M356.967 -2.45117H430.718M356.967 -2.45117L430.718 94.7998M430.718 -2.45117L467.594 46.1743M430.718 -2.45117L356.967 94.7998M467.594 46.1743L430.718 94.7998M430.718 94.7998H356.967",
    stroke: "#EEEFEF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.461 143.859L137.141 94.7998M100.461 143.859L137.141 192.919M100.461 143.859H247.768M137.141 94.7998H210.892M137.141 94.7998L210.892 192.919M210.892 94.7998L247.768 143.859M210.892 94.7998L137.141 192.919M247.768 143.859L210.892 192.919M210.892 192.919H137.141",
    stroke: "#EEEFEF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.31885 192.918L28.0785 144.293M-8.31885 192.918L28.0785 241.544M-8.31885 192.918H137.855M28.0785 144.293H101.263M28.0785 144.293L101.263 241.544M101.263 144.293L137.855 192.918M101.263 144.293L28.0785 241.544M137.855 192.918L101.263 241.544M101.263 241.544H28.0785",
    stroke: "#EEEFEF",
    strokeWidth: 1.5
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeaderPolygonLightLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "header-polygon-light-large.2f6a8bba15ca9ceabf2ed05b8ecc3064.svg";